<template>
  <div v-bind:class="bodyClassObject">
    <div class="wrapper">
      <HeaderComponent></HeaderComponent>
      <MenuComponent active="camps"></MenuComponent>
      <CampsContentComponent v-bind:countries="countries" v-bind:camps="camps"></CampsContentComponent>
      <FooterComponent></FooterComponent>
      <AlertComponent></AlertComponent>
    </div>
  </div>
</template>

<script>
import MenuComponent from './Menu';
import CampsContentComponent from './CampsContent';
import HeaderComponent from './Header';
import FooterComponent from './Footer';
import AlertComponent from './Alert';
import axios from 'axios';

export default {
  name: 'Camps',
  data () {
    return {
      camps: [],
      countries: []
    };
  },
  created () {
    var self = this;

    // axios.defaults.headers.common['Authorization'] =
    //   // eslint-disable-next-line no-undef
    //     $cookies.get('jwt');

    const AuthStr = 'Bearer ' + JSON.parse(localStorage.getItem('user')).token;

    axios.get(
      window.host + '/sport-courses/camps', {headers: { Authorization: AuthStr }})
      .then(function (response) {
        console.log(response.data);
        self.camps = response.data;
      })
      .catch(function (error) {
        console.log(error);
      });

    axios.get(window.host + '/countries')
      .then(function (response) {
        console.log(response.data);
        self.countries = response.data;
      })
      .catch(function (error) {
        console.log(error);
      });
  },
  components: {
    CampsContentComponent,
    MenuComponent,
    HeaderComponent,
    FooterComponent,
    AlertComponent
  },
  computed: {
    bodyClassObject: function () {
      return {
        'skin-blue': window.application === 'cabinet',
        'skin-green': window.application !== 'cabinet'
      };
    }
  }
};
</script>

<style scoped>
  h1, h2 {
    font-weight: normal;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    display: inline-block;
    margin: 0 10px;
  }

  a {
    color: #42b983;
  }

  .home__wrapper {
  }
</style>
